import script from "./TransportTypeTile.vue?vue&type=script&setup=true&lang=js"
export * from "./TransportTypeTile.vue?vue&type=script&setup=true&lang=js"

import "./TransportTypeTile.vue?vue&type=style&index=0&id=d08038fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d08038fe"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg});
